<template>
	<div class="planner-datebar resource-booking-datebar" aria-label="Day and Week Navigation">
		<div class="container">
			<div class="text-xs-center">
				<h2 class="planner-date-month">{{ selectedDate.format('MMMM') }}</h2>
			</div>
			<div class="planner-date-controls">
				<button class="btn planner-date-btn planner-date-btn-prev" :disabled="!prevWeekEnabled" @click="prevWeekClicked">
					<span class="ico-arrow-left icon-adjust-horiz icon-adjust-vert"></span>
					<span class="sr-only">Previous Week</span>
				</button>
				<div class="planner-date-week">
					<div class="planner-date" :class="{'planner-date-current': day.today}" v-for="day of daysViewing" :key="day.index" data-testid="resourceBookingDateNavResults">
						<div class="sr-only" :id="`day-total-${day.index}`">{{ day.display.total }} results</div>
						<label class="planner-date-radio" data-testid="plannerDate" :for="`day-${day.index}`" :aria-label="day.display.ariaDate" :aria-describedby="`day-total-${day.index}`">
							<input
								:id="`day-${day.index}`"
								type="radio"
								:value="day.value"
								:disabled="day.isInPast"
								v-model="selectedNavDay"
								class="planner-date-radio-input"
								@change="selectedChanged"
							/>
							<span class="planner-date-day">
								<span class="planner-date-dayname">
									<span class="hidden-lg-up">{{ day.display.dayLetter }}</span>
									<span class="hidden-md-down">{{ day.display.dayNameFull }}</span>
								</span>
								<span class="planner-date-number">{{ day.display.dayNum }}</span>
							</span>
						</label>
					</div>
				</div>
				<button class="btn planner-date-btn planner-date-btn-next" :disabled="!nextWeekEnabled" @click="nextWeekClicked">
					<span class="ico-arrow-right icon-adjust-horiz icon-adjust-vert"></span>
					<span class="sr-only">Next Week</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { momentProvider } from '@/services/clock.service';

export default defineComponent({
	name: 'ResourceBookingDateBarSub',
	props: {
		viewMode: {
			default: 'day',
			type: String
		},
		days: {
			default: () => [],
			type: Array
		},
		selectedDate: {
			default: null,
			type: Object
		},
		maxDay: {
			default: null,
			type: Object
		}
	},
	data() {
		return {
			selectedNavDay: null,
			prevWeekEnabled: false,
			nextWeekEnabled: false
		};
	},
	computed: {
		daysViewing() {
			return this.days.filter(d => d.isViewing);
		}
	},
	watch: {
		selectedDate: function(newSelectedDate) {
			this.selectedNavDay = newSelectedDate.format('YYYY-MM-DD');
			this.enableDisableWeekNav();
		},
		maxDay: function(newMaxDay) {
			this.maxDay = newMaxDay;
			this.enableDisableWeekNav();
		}
	},
	mounted() {
		this.selectedNavDay = this.selectedDate.format('YYYY-MM-DD');
	},
	methods: {
		enableDisableWeekNav() {
			this.prevWeekEnabled = momentProvider().startOf('week').isBefore(this.selectedDate.clone().startOf('week'));
			this.nextWeekEnabled = this.maxDay.clone().endOf('week').isAfter(this.selectedDate.clone().endOf('week'));
		},
		selectedChanged() {
			const day = this.days.find(element => element.value === this.selectedNavDay);
			this.$emit('dayChanged', day);
		},
		prevWeekClicked() {
			this.selectedNavDay = this.selectedDate.clone().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD');
			const day = this.days.find(element => element.value === this.selectedNavDay);
			this.$emit('weekChanged', day);
		},
		nextWeekClicked() {
			this.selectedNavDay = this.selectedDate.clone().add(1, 'weeks').startOf('week').format('YYYY-MM-DD');
			const day = this.days.find(element => element.value === this.selectedNavDay);
			this.$emit('weekChanged', day);
		}
	}
});
</script>

<style lang="scss" scoped>
@import "../styles/resourceBookingDateBar.scss";
</style>
